class CartMain extends Component {
	constructor(el) {
		super(el);
		this.form = this.$el.closest('form');
		this.debounceInterval = undefined;
		this.addEventListeners();
	}

	reRenderCart(data) {
		const htmlData = new DOMParser().parseFromString(data, 'text/html');
		const componentSource = htmlData.querySelector('[data-step-cart]');
		this.$el.innerHTML = componentSource.innerHTML;

		Component.initComponents();
	}

	updateCart(params) {
		let formData = new FormData(this.form);
		let action = Object.keys(params).length ? params : window.location.pathname;
		EventBus.getInstance().dispatchEvent('showGlobalSpinner');
		formData.append('ajax-cart', '1');

		fetch(action, {
			method: 'POST',
			body: formData
		})
		.then(res => res.json())
		.then(data => this.onCartUpdated(data))
		.finally(() => EventBus.getInstance().dispatchEvent('hideGlobalSpinner'));
	}

	onCartUpdated(data) {
		this.reRenderCart(data.views['Cart']);
		if(data.remarketingCodes) {
			Util.appendToBody(data.remarketingCodes);
		}
	}

	addEventListeners() {
		EventBus.getInstance().addEventListener('orderUpdateStepCart', e => {
			this.debounceInterval && clearTimeout(this.debounceInterval);
			this.debounceInterval = setTimeout(() => this.updateCart(e.detail), 300);
		});
	}
}
